/**
 * @module employees
 */
import { createReducer } from '@reduxjs/toolkit';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { employeeActions } from '~/behaviors/actions/employee.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

/**
 * Iterate over each element of `action.payload.entities.employees` and merge each with any
 * existing entity with the same ID in the state (or create new one if none exist).
 */
const merge = (state, action) => {
  const employees = action?.payload?.entities?.employees || {};

  Object.values(employees).forEach((employee) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[employee.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[employee.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...employee,
    };
  });
};

const employees = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(employeeActions.fetchEmployees.fulfilled, merge);
  builder.addCase(employeeActions.fetchEmployee.fulfilled, merge);
  builder.addCase(employeeActions.pageEmployees.fulfilled, merge);
  builder.addCase(employeeActions.modifyEmployee.fulfilled, merge);
  builder.addCase(employeeActions.createEmployee.fulfilled, merge);
});

export default employees;
